import { Box, styled } from "@mui/material";
interface Props {
  setMapOverlayContainer: (container: HTMLDivElement) => void;
}
export function LoadingBox(props: Props) {
  const { setMapOverlayContainer } = props;
  return (
    <StyledBox ref={(ref: HTMLDivElement) => setMapOverlayContainer(ref)} />
  );
}

const StyledBox = styled(Box)`
  position: absolute;
  width: 100%;
  z-index: 9999;

  background-color: coral;
`;
